import { computed, Ref } from "@vue/composition-api";

export interface NumericAttr {
  numeric: Readonly<Ref<boolean>>;
  numericError: Readonly<Ref<boolean>>;
}

export const numericValidator = (
  inputRef: Ref<string | number>,
  inputValueDirty: Ref<boolean>
): NumericAttr => {
  const numeric = computed(() => Number.isInteger(Number(inputRef.value)));
  return {
    numeric,
    numericError: computed(() => !numeric.value && inputValueDirty.value)
  };
};
